export default __webpack_public_path__ + "3fe317756a94fbe88265edf4262995c7.svg";